import React, { useState, useEffect, useCallback } from "react";
import style from "./SubscriptionsStyle";
import { getSubscriptionSummary } from "../../Services/subscriptionService";
import { useNavigate } from "react-router-dom";
import CreateSubscriptionModal from "../../Components/Subscriptions/CreateSubscriptionModal/CreateSubscriptionModal";

export default function Subscriptions() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const summaryData = await getSubscriptionSummary();
      setSummary(summaryData);
    } catch (error) {
      console.error("Falha ao carregar assinaturas", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  
  const handleSuccess = () => {
    setIsModalOpen(false);
    fetchData();
  }

  const formatCurrency = (value) =>
    (value ?? 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("pt-BR");
  };

  const getStatusInfo = (status) => {
    switch (status) {
      case 1:
        return { text: "Ativa", style: style.statusActive };
      case 2:
        return { text: "Pendente", style: style.statusPending };
      case 3:
        return { text: "Bloqueada", style: style.statusBlocked };
      default:
        return { text: "Desconhecido", style: {} };
    }
  };

  const handleRowClick = (id) => {
    navigate(`/subscriptions/${id}`);
  };

  if (loading) {
    return <div style={style.loadingContainer}>Carregando Assinaturas...</div>;
  }

  return (
    <>
      <div style={style.container}>
        <header style={style.header}>
          <div>
            <h1 style={style.title}>Gerenciamento de Assinaturas</h1>
            <p style={style.subtitle}>
              Visualize, filtre e gerencie todas as assinaturas dos seus clientes.
            </p>
          </div>
          <button style={style.createButton} onClick={() => setIsModalOpen(true)}>
            + Criar Assinatura
          </button>
        </header>

        {summary && (
          <div style={style.statsGrid}>
            <div style={style.statCard}>
              <p style={style.statLabel}>Receita Mensal Recorrente (MRR)</p>
              <h2 style={style.statValue}>
                {formatCurrency(summary.totalValueActiveSubscriptions)}
              </h2>
            </div>
            <div style={style.statCard}>
              <p style={style.statLabel}>Assinaturas Ativas</p>
              <h2 style={style.statValue}>{summary.activeSubscriptionsCount}</h2>
            </div>
            <div style={style.statCard}>
              <p style={style.statLabel}>Pagamentos Pendentes</p>
              <h2 style={style.statValue}>
                {summary.pendingPaymentSubscriptionsCount}
              </h2>
            </div>
            <div style={style.statCard}>
              <p style={style.statLabel}>Clientes Bloqueados</p>
              <h2 style={style.statValue}>{summary.blockedSubscriptionsCount}</h2>
            </div>
          </div>
        )}

        <div style={style.listContainer}>
          <div style={style.table}>
            <div style={{ ...style.tableRow, ...style.tableHeader }}>
              <div style={style.tableCell}>Cliente</div>
              <div style={style.tableCell}>Plano</div>
              <div style={{ ...style.tableCell, ...style.textCenter }}>Valor</div>
              <div style={{ ...style.tableCell, ...style.textCenter }}>
                Expira em
              </div>
              <div style={{ ...style.tableCell, ...style.textCenter }}>
                Status
              </div>
            </div>
            {summary?.allSubscriptions?.length > 0 ? (
              summary.allSubscriptions.map(
                ({ subscription, subscriptionType, enterprise }) => {
                  const statusInfo = getStatusInfo(subscription.status);
                  return (
                    <div
                      key={subscription.id}
                      style={style.tableRow}
                      onClick={() => handleRowClick(subscription.id)}
                    >
                      <div style={style.tableCell}>
                        <div style={style.clientInfo}>
                          <span style={style.clientName}>{enterprise.name}</span>
                          <span style={style.clientCnpj}>
                            CNPJ: {enterprise.cnpj}
                          </span>
                        </div>
                      </div>
                      <div style={style.tableCell}>{subscriptionType.name}</div>
                      <div
                        style={{
                          ...style.tableCell,
                          ...style.textCenter,
                          ...style.valueCell,
                        }}
                      >
                        {formatCurrency(subscriptionType.value)}
                      </div>
                      <div style={{ ...style.tableCell, ...style.textCenter }}>
                        {formatDate(subscription.expirationDate)}
                      </div>
                      <div style={{ ...style.tableCell, ...style.textCenter }}>
                        <span
                          style={{ ...style.statusBadge, ...statusInfo.style }}
                        >
                          {statusInfo.text}
                        </span>
                      </div>
                    </div>
                  );
                }
              )
            ) : (
              <div style={style.noResults}>Nenhuma assinatura encontrada.</div>
            )}
          </div>
        </div>
      </div>
      {isModalOpen && <CreateSubscriptionModal onClose={() => setIsModalOpen(false)} onSuccess={handleSuccess} />}
    </>
  );
}